import { Component } from '@angular/core';
import { AbstractAddComponent } from '../abstract-add/abstract-add.component';
import { ModalService } from '../../../../widgets/entry-components/modal/services/modal.service';
import { ActionSheetController } from '@ionic/angular';
import { TranslatePipe } from '../../../translate/pipes/translate.pipe';
import { FormArray } from '@angular/forms';
import { NameComponent, getNameFormGroup } from '../../../../widgets/entry-components/modal/components/name/name.component';
import { AddressComponent, getAddressFormGroup } from '../../../../widgets/entry-components/modal/components/address/address.component';
import {
  TelecomAddComponent, getTelecomFormGroup
} from '../../../../widgets/entry-components/modal/components/telecom-add/telecom-add.component';
import { ContactComponent, getContactFormGroup } from '../../../../widgets/entry-components/modal/components/contact/contact.component';
import { AssociativeArray } from './../../../../user/login/shared/ass-array.model';

@Component({
  selector: 'inc-abstract-add-wmodal',
  template: ''
})
export class AbstractAddWmodalComponent<T> extends AbstractAddComponent<T> {

  modalComponents: AssociativeArray = {
    name: () => NameComponent,
    address: () => AddressComponent,
    telecom: () => TelecomAddComponent,
    contact: () => ContactComponent
  };

  constructor(
    protected modalService: ModalService, protected actionSheetController: ActionSheetController,
    protected translatePipe: TranslatePipe) {
    super();
  }

  discard() {
    if (this.inData) {
      this.reset();
      this.form.patchValue(this.inData);
      this.pushInto();
    }
  }

  pushInto() {
    this.pushIntoFormArray(this.inData, 'name', getNameFormGroup);
    this.pushIntoFormArray(this.inData, 'address', getAddressFormGroup);
    this.pushIntoFormArray(this.inData, 'telecom', getTelecomFormGroup);
    this.pushIntoFormArray(this.inData, 'contact', getContactFormGroup);
  }

  openModal(componentName: string, param?: any) {
    this.modalService.presentModal(this.modalComponents[componentName](), param).then(modal => {
      modal.onDidDismiss().then(detail => {
        if (detail.data) {
          if (detail.data.value.hasOwnProperty(componentName)) {
            const formArray =
              this.form.controls[componentName] ? this.form.controls[componentName] as any : new FormArray([]);
            formArray.push(detail.data.value[componentName]);
            this.form.setControl(componentName, formArray);
          }
        }
      });
    });
  }

  pushIntoFormArray(inData: T, componentName: string, getFormFun?: any) {
    const formArray =
      this.form.controls[componentName] ? this.form.controls[componentName] as any : new FormArray([]);
    if (inData.hasOwnProperty(componentName)) {
      for (const data of inData[componentName]) {
        const formGroup = getFormFun();
        formGroup.patchValue(data);
        formArray.push(formGroup);
      }
    }
    this.form.setControl(componentName, formArray);
  }

  deleteFromFormArray(formArrayName: string, index: number): void {
    (this.form.get(formArrayName) as FormArray).removeAt(index);
  }

  async addDetails() {
    const actionSheet = await this.actionSheetController.create({
      header: this.translatePipe.transform('ADDOTHERDATAS'),
      buttons: [
        {
          text: this.translatePipe.transform('ADDRESS'),
          icon: 'business',
          handler: () => {
            this.openModal('address');
          }
        }, {
          text: this.translatePipe.transform('AVAILABILITY'),
          icon: 'call',
          handler: () => {
            this.openModal('telecom');
          }
        }, {
          text: this.translatePipe.transform('CONTACT_PERSON'),
          icon: 'contact',
          handler: () => {
            this.openModal('contact');
          }
        }, {
          text: this.translatePipe.transform('BACK'),
          icon: 'close',
          role: 'cancel'
        }]
    });
    await actionSheet.present();
  }

}
